export default {"src":"/_next/static/media/faceboock.e80a1942.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};